/*
 * @providesModule GameOperationsManagerStyle
 *
 */

import {matchListMarginHorizontal} from 'MatchSelectListStyle';
import Sizes from 'Sizes';
import {Platform, StyleSheet} from 'react-native';

// Additional overlap to ensure a margin of 5 between the GameOperationsContainer and the edges of the screen
const CONTAINER_OVERLAP_LEFT = Platform.select({
  ios: 5,
  default: 0,
});

const CONTAINER_OVERLAP_RIGHT = Platform.select({
  ios: 5,
  default: -3,
});

// On iOS, this allows the GameOperationsContainer to be flush with the left edge of the screen
const CONTAINER_MARGIN_LEFT = -1 * matchListMarginHorizontal;
// Ensure a margin of 5 between the GameOperationsContainer and the right edge of the screen
const CONTAINER_MARGIN_RIGHT = -1 * CONTAINER_OVERLAP_RIGHT;

export const GAME_OPERATIONS_CONTAINER_MARGIN_TOP = 8;

export const gameOperationsManagerStylesFn = () =>
  StyleSheet.create({
    container: {
      marginLeft: CONTAINER_MARGIN_LEFT,
      marginRight: Sizes.dynamic({sm: CONTAINER_MARGIN_RIGHT, tablet: 3}),
      marginTop: GAME_OPERATIONS_CONTAINER_MARGIN_TOP,
    },

    headerFooterContainer: {
      width: Sizes.dynamic({
        sm: matchListMarginHorizontal - CONTAINER_OVERLAP_LEFT,
        tablet: matchListMarginHorizontal,
      }), // moving the 1st LTO outside the bounds of the list margin
    },

    trophyProgressBarContainer: {
      position: 'absolute',
      width: 40,
      height: 6,
      zIndex: 2,
      bottom: 2,
      alignSelf: 'center',
    },

    trophyProgressBarBackgroundBar: {
      backgroundColor: '#FFF',
      borderColor: '#DCDCDC',
      borderRadius: 4,
      padding: 0,
    },
  });
